// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"f21ec7d2","container":"d0e9c5d8","titleRow":"a6e845a5","title":"f753f88a","archived":"e1e90001","iconLock":"ee22141a","fullScreenForm":"e33cc6e8"};